import { AfterViewInit, Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as $ from 'jquery';
import 'magnific-popup';
import { fromEvent, Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-global',
  templateUrl: './global.component.html',
  styleUrls: ['./global.component.css']
})
export class GlobalComponent implements AfterViewInit, OnInit, OnDestroy {
  windowScrolled: boolean | undefined;
  closeResult: string | undefined;
  constructor(private modalService: NgbModal) { }
  // Search
  openSearch(content: any) {
   this.modalService.open(content, { centered: true, windowClass: 'search-modal' });
  }
//  Sticky Nav
  @HostListener("window:scroll", [])
  onWindowScroll() {
   this.windowScrolled = window.scrollY > 100;
  }

  

  // scrollToTop() {
  //   (function smoothscroll() {
  //     var currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
  //     if (currentScroll > 0) {
  //       window.requestAnimationFrame(smoothscroll);
  //       window.scrollTo(0, currentScroll - (currentScroll / 8));
  //     }
  //   })();
  // }
  // navigation
  navMethod: boolean = false;
  toggleNav() {
    this.navMethod = !this.navMethod;
  }
  // Canvas
  canvasMethod: boolean = false;
  toggleCanvas() {
    this.canvasMethod = !this.canvasMethod;
  }
  //Mobile 
  open: boolean = false;
  trigger(item: { open: boolean; }) {
    item.open = !item.open;
  }
  // Add class on resize and onload window
  visible: boolean = false;
  breakpoint: number = 1199;
  public innerWidth: any;

  onlineEvent: Observable<Event>;
  offlineEvent: Observable<Event>;
  subscriptions: Subscription[] = [];

  connectionStatusMessage: string;
  connectionStatus: string;

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  detectHeader() {
    this.innerWidth = window.innerWidth;
    this.visible = this.innerWidth >= this.breakpoint;
  }
  ngOnInit(): void {
    this.onlineEvent = fromEvent(window, 'online');
    this.offlineEvent = fromEvent(window, 'offline');

    this.subscriptions.push(this.onlineEvent.subscribe(e => {
      this.connectionStatusMessage = 'Great..you are back online';
      this.connectionStatus = 'online';
      console.log('Online...');
    }));

    this.subscriptions.push(this.offlineEvent.subscribe(e => {
      this.connectionStatusMessage = 'Connection lost!! You are not connected to internet';
      this.connectionStatus = 'offline';
      console.log('Offline...');
    }));
    this.detectHeader();
  }
  ngAfterViewInit(): void {
    ($('.popup-youtube') as any).magnificPopup({
      type: 'iframe'
    });
    ($('.gallery-img-popup') as any).magnificPopup({
      type: 'image',
      gallery: {
        enabled: true,
      },
      mainClass: 'mfp-fade',
    });
  }

  //Scroll to Top
  showScroll: boolean;
  showScrollHeight = 600;
  hideScrollHeight = 10;


  // @HostListener('window:scroll', [])
  // onWindowScroll() {
  //   if ((window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop) > this.showScrollHeight) {
  //     console.log(1)
  //     this.showScroll = true;
  //   }
  //   else if (this.showScroll && (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop) < this.hideScrollHeight) {
  //     console.log(2)
  //     this.showScroll = false;
  //   }
  // }
  scrollToTop(){
    window.scroll(0,0);
  }

  // scrollToTop() {
  //   (function smoothscroll() {
  //     var currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
  //     if (currentScroll > 0) {
  //       window.requestAnimationFrame(smoothscroll);
  //       //window.scrollTo(1,currentScroll - (currentScroll / 8));
  //     }
  //   })();
  // }


}
